var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 9H1C0.448 9 0 8.552 0 8V1C0 0.448 0.448 0 1 0H6C6.552 0 7 0.448 7 1V8C7 8.552 6.552 9 6 9Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 16H1C0.448 16 0 15.552 0 15V12C0 11.448 0.448 11 1 11H6C6.552 11 7 11.448 7 12V15C7 15.552 6.552 16 6 16Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6H10C9.448 6 9 5.552 9 5V1C9 0.448 9.448 0 10 0H15C15.552 0 16 0.448 16 1V5C16 5.552 15.552 6 15 6Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16H10C9.448 16 9 15.552 9 15V9C9 8.448 9.448 8 10 8H15C15.552 8 16 8.448 16 9V15C16 15.552 15.552 16 15 16Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu-icon.c0cc18bf79e7691e9dcf9d5959b7518a.svg";
export { ForwardRef as ReactComponent };